/**
 * 登录
 */
const React = require('react');
const $ = require('jquery');
const ReactDOM = require('react-dom');
const res = require('@common/res');
const com = res.com;
const cfg = res.cfg;
const utils = res.utils;
const hcComponent = require('@hcComponent');
const css = require('@theme/login.scss');
const component = require('@hcComponent');
const Modal = hcComponent.dialog.Modal;
const Input = component.input.Input;
const Button = component.button.Button;
const Prompt = component.dialog.Prompt;
var lock = false;
var lock2 = false;
var getcode = 0;//是否已经获取验证码 0初始，1已经获取验证码（有效中），2获取过验证码（失效中）
const CheckBox = hcComponent.checkbox.CheckBox;

// 图片验证码的获取
let urlStr = window.location.href;  // 获取当前窗口地址
let urlArr = urlStr.split("/dist/page/login.html");  // 分割字符串
let urlArrPrev = urlArr[0]; // 拿到.com之前的字符串
let webUrl = urlArrPrev.toString() + "/cloudec/fo/order/user/user/createImg"  // 拼接




class Login extends React.Component {
    constructor(props) {
        super(props);

        utils.bindFunc(this, ['onLoginSubmit', 'getSmCodeOne', 'Cancels', 'addCookie', 'getCookie', 'codeImg', 'updateUserSeasonYear',
            'closeResetPwd', 'showResetModal', 'toResetPwdPage', 'closeRelation','checkboxChange','okRead','closeRead','openPdf','onCancelPdf']);

        this.state = {
            model: 'username',
            data: {
                tempPhone: ''//临时记录的手机号
            },
            errFlg: false,
            btnText: '登录',
            btnCodeText: '获取验证码',
            discodeBtn: false,
            relationTag: false,
            smsTimer: 60,
            mes: '',
            modalVisible: {
                resetPassword: false,
                importExcel: false,
                importExcelResult: false,
                openOnePdf:false,
            },
            resetPwdParam: {
                resetPwd: false,
                msg: '长时间未修改密码'
            },
            relation: {
                username: '',
                phone: ''
            },
            checked:false,
            ieVersion: null,
            openOnePdfUrl:'',
            pdfPageType:0,
            readVisible:false,
        };
    }

    componentDidMount() {
        this.state.ieVersion = com.checkIEVersion();
        this.setState();
        window.onresize = function () {
            var height = $(window).height();
            $(this.refs.login).css('min-height', height + 'px');
        }.bind(this);
        this.addCookie("cookeiof", 1,1)
        if (window.location.href == "http://10.18.15.51:84/dist/page/login.html" || window.location.href == "http://222.84.157.44:18180/dist/page/login.html") {
            //         let urls ="https://www.iuscc.com"
            //         let ziti = "                 广西糖料蔗大数据服务平台域名变更公告\n"+
            //         "尊敬的用户：\n"+"       您好！根据国务院办公厅《关于加强政府网站域名管理的通知》（国办函[2018]55号）、广西壮族自治区人民政府办公厅《关于规范政府网站名称及域名的通知》（桂政办电[2018]286号）要求，广西糖料蔗大数据服务平台域名变更为："+urls+"，原IP 222.84.157.44:18180将于12月x号停止使用，请您知悉。\n\n"+
            //        "                                                    广西糖料蔗大数据服务平台"
            //    alert(ziti);
            this.setState({
                modalVisible: {
                    resetPassword: true
                }
            })

        }

        window.onresize();




        document.getElementById("img").src = webUrl;
        console.log(document.getElementById("img").src)


    }

    /**
     * 获取管理员联系方式
     */
    adminRelation() {
        com.getJson({
            url: cfg.get('relation'),
            type: 'GET',
        }).done(res => {
            const data = res.data;
            this.setState({
                relationTag: true,
                relation: {
                    username: data.name,
                    phone: data.phone
                }
            });
        }).fail(err => {
            Prompt.error(err.codeMsg);
        }).always(res => {

        });
    }


    Cancels(){

        this.setState({
            modalVisible: {
                resetPassword: false
            }
         })
    }
       //写Cookie
       addCookie(objName, objValue, objHours) {
        var str = objName + "=" + escape(objValue); //编码
        if (objHours > 0) {//为0时不设定过期时间，浏览器关闭时cookie自动消失
            var date = new Date();
            var ms = objHours * 3600 * 1000;
            date.setTime(date.getTime() + ms);
            str += "; expires=" + date.toGMTString();
        }
        document.cookie = str;
    }
    //读Cookie
    getCookie(objName) {//获取指定名称的cookie的值
        var arrStr = document.cookie.split("; ");
        for (var i = 0; i < arrStr.length; i++) {
            var temp = arrStr[i].split("=");
            if (temp[0] == objName) return unescape(temp[1]);  //解码
        }
        return "";
    }

    //切换模式
    changeModel(model) {
        var _this = this;
        _this.state.model = model;
        _this.setState();

        $('.yzm').show();
        $('#img').show();

    }

    changeModel2(model) {
        var _this = this;
        _this.state.model = model;
        _this.setState();

        $('.yzm').hide();
        $('#img').hide();

    }

    onInputChange(e) {
        let name = e.target.name;
        let value = e.target.value;
        this.state.data[name] = value;
        this.state.errFlg = false;
        this.setState();
    }

    updateUserSeasonYear(userInfo) {
        com.getJson({
            url: cfg.get('updateUserSeasonYear'),
            type: 'POST',
        }).done(res => {
        }).fail(err => {
            Prompt.error(err.codeMsg);
        }).always(res =>{
            window.location.href = userInfo.homePage;
        });
    }

    showResetModal(userInfo, msg) {
        this.setState({
            userInfo: userInfo,
            resetPwdParam: {
                resetPwd: true,
                msg: msg
            }
        });
    }

    toResetPwdPage(type) {
        if (type === 'phone') {
            let phone = this.state.userInfo.phone;
            if (phone == undefined || phone == '') {
                Prompt.warn('未绑定手机号, 无法使用手机号修改密码. 请使用原密码修改');
                return;
            }
        }
        const params = "?userId=" + this.state.userInfo.userId + "&phone=" + this.state.userInfo.phone + "&model=" + type;
        window.location.href = "rePwd.html" + params;
    }

    onLoginSubmit(e) {
        e.preventDefault();
        this.onLoginBtn();
    }
    onLoginBtn(){
        let _this = this;
        if(!this.state.checked){
            this.setState({
                    readVisible: true
            })
            return
        }
        if (this.state.model == 'username') {
            if (lock) {
                return;
            }
            let { username, password, codeImg } = this.state.data;
            if (username == undefined || username == '') {
                Prompt.warn('请输入账号名称');
                return;
            }
            if (password == undefined || password == '') {
                Prompt.warn('请输入密码');
                return;
            }
            // 判断是否输入了图片验证码
            if (codeImg == undefined || codeImg == '') {
                Prompt.warn('请输入图片验证码');
                return;
            }else if (codeImg != codeImg){
                Prompt.warn('图片验证码输入有误');
                return;
            }
            lock = true;
            this.setState({
                btnText: '正在登录...'
            });
            com.getJson({
                url: cfg.get('doLogin'),
                type: 'POST',
                data: JSON.stringify({
                    username: username,
                    password: password,
                    codeImg: codeImg,
                    departType: '2',//表示糖厂
                    agreeFlag:'0'
                }),
                contentType: 'application/json'
            }).done(res => {
                Prompt.success('正在跳转...');
                var userInfo = res.data;
                localStorage.userInfo = JSON.stringify(userInfo);//
                // window.location.href = './index.html#/home';
                //登陆成功更新用户当前榨季为平台默认榨季
                _this.updateUserSeasonYear(userInfo);
                //window.location.href = userInfo.homePage;

            }).fail(err => {
                if (err.data != null) {
                    _this.showResetModal(err.data, err.codeMsg);
                    return;
                }
                Prompt.error('登录失败！' + err.codeMsg);

            }).always(() => {
                lock = false;
                this.setState({
                    btnText: '登录'
                });
            });
        }
        else if (this.state.model == 'phone') {

            if (lock2) {
                return;
            }

            if (!_this.state.data.tempPhone || _this.state.data.tempPhone == '') {
                Prompt.warn('请输入手机号');
                return;
            }

            if (!(_this.state.data.tempPhone).match(com.regExp.cellphone)) {
                Prompt.warn('手机号格式错误');
                return;
            }

            if (getcode == 0) {
                Prompt.warn('请获取验证码');
                return;
            }

            if (_this.state.data.tempPhone != _this.state.data.phone) {
                Prompt.warn('手机号信息不正确，请重新获取验证码');
                return;
            }

            if (_this.state.data.smsCode === undefined || _this.state.data.smsCode == '') {
                Prompt.warn("短信验证码不能为空");
                return;
            }

            this.setState({
                btnText: '正在登录...'
            });
            lock2 = true;

            com.getJson({
                url: cfg.get('comFirm'),
                type: 'post',
                data: JSON.stringify({
                    phone: this.state.data.phone,
                    msg: this.state.data.smsCode,
                    departType: '2',//表示糖厂
                    agreeFlag:'0'
                }),
                contentType: 'application/json'
            }).done(res => {
                Prompt.success('正在跳转...');
                var userInfo = res.data;
                localStorage.userInfo = JSON.stringify(userInfo);//
                //window.location.href = './index.html#/home';
                //登陆成功更新用户当前榨季为平台默认榨季
                _this.updateUserSeasonYear(userInfo);
                //window.location.href = userInfo.homePage;
            }).fail(err => {
                if (err.data != null) {
                    _this.showResetModal(err.data, err.codeMsg);
                    return;
                }
                Prompt.error('登录失败！' + err.codeMsg);

                $('.fp-userWarp2').hide()
            }).always(() => {
                lock2 = false;
                this.setState({
                    btnText: '登录'
                });
            });
        }
    }
    closeResetPwd() {
        this.setState({
            resetPwdParam: {
                resetPwd: false
            }
        })
    }

    // 获取验证码
    getSmCodeOne() {
        let _this = this;

        if (!_this.state.data.tempPhone || _this.state.data.tempPhone == '') {
            Prompt.warn('请输入手机号');
            return;
        }

        if (!(_this.state.data.tempPhone).match(com.regExp.cellphone)) {
            Prompt.warn('手机号格式错误');
            return;
        }
        // 获取短信验证码
        com.getJson({
            url: cfg.get('sendSmsCodeForRetrievePwdCode'),
            data: { mobile: this.state.data.tempPhone },
            type: 'post'
        }).done(res => {
            // this.smsCount();

            _this.smsCount();  // 执行验证码倒计时

            Prompt.success(res.codeMsg);

            _this.state.data.phone = _this.state.data.tempPhone;
            _this.setState();
            getcode = 1;

            // _this.smsCount();

        }).fail(res => {
            // this.smsCount();
            Prompt.error(res.codeMsg);
            console.log(typeof res.code);
            $('#btn1').attr('disabled',true);
            getcode = 2;

        });



        // _this.smsCount();
    }

    closeRelation() {
        this.setState({
            relationTag: false
        });
    }

    smsCount() {// 获取验证码倒计时

        let siv = setInterval(() => {
            let smsTimer = (this.state.smsTimer - 1);
            this.setState({ smsTimer: smsTimer, btnCodeText: smsTimer + " 秒后重发", discodeBtn: true }, () => {
                if (this.state.smsTimer === 0) {
                    clearInterval(siv);
                    this.setState({ smsTimer: 60, btnCodeText: '重新发送', discodeBtn: false });
                    getcode = 2;
                }
            });
        }, 1000);
    }




    // 点击切换图片验证码
    codeImg() {
        document.getElementById("img").src = webUrl + '?' + Math.random();
        console.log(document.getElementById("img").src);
    }

    //点击显示\隐藏密码
    passwordImg(){
        let password = document.getElementById('password');
        let anniu = document.getElementById('conceal');
            if(password.type==='password') {
                password.setAttribute('type','text');
                anniu.classList.add('yincang');
            }else{
                password.setAttribute('type','password');
                anniu.classList.remove('yincang');
            }
    }

    checkboxChange(data, checked) {
        this.setState({
            checked: checked
        });
    }

    okRead(){
        this.setState({
            checked:true,
            readVisible: false
        },()=>{
            this.onLoginBtn()
        })

    }
    closeRead(){
        this.setState({
                readVisible: false
        })
    }
    openPdf(type){
        let str = ''
        if(type!=this.state.pdfPageType){
            this.setState({
                pdfPageType:type,
            })
            str = '#page=1'
        }

        let url = type==1?'/dist/lib/commonFile/pdf/（正式稿）广西糖料蔗大数据服务平台服务协议.pdf'+ str:'/dist/lib/commonFile/pdf/（正式稿）广西糖料蔗大数据服务平台隐私政策.pdf'+ str
        this.setState({
            openOnePdfUrl:url,
            modalVisible: {
                openOnePdf: true
            }
        })
    }
    onCancelPdf(){
        this.setState({
            modalVisible: {
                openOnePdf: false
            }
        })
    }
    render() {
        return (
            <div ref="login">
                <form id="loginForm" onSubmit={this.onLoginSubmit}>
                    <div className="bg" />
                    <div className='login-top'>
                        <img
                            src={require('../../theme/default/images/login/logo.png')}
                        />
                        <p>广西糖料蔗大数据服务平台<i>V糖厂端</i></p>
                    </div>
                    <div className='login-content'>
                        <div className='login-c-top'>
                            <ul>
                                <li className={this.state.model == 'username' ? 'on' : ''} onClick={this.changeModel.bind(this, 'username')}>账号密码登录</li>
                                <li className={this.state.model == 'phone' ? 'on' : ''} onClick={this.changeModel2.bind(this, 'phone')}>手机号登录</li>
                            </ul>
                        </div>
                        {
                            this.state.model == 'username' ? <div>
                                <div className="login-c-wrap icon-user">
                                    <Input
                                        className="login-input"
                                        placeholder="请输入用户名"
                                        name="username"
                                        value={this.state.data.username}
                                        onChange={this.onInputChange.bind(this)}
                                    />
                                </div>
                                <div className="login-c-wrap icon-password">
                                    <Input
                                        className="login-input"
                                        type="password"
                                        placeholder="请输入登录密码"
                                        name="password"
                                        maxLength="20"
                                        value={this.state.data.password}
                                        onChange={this.onInputChange.bind(this)}
                                    />
                                    <div className="conceal" id='conceal' onClick={this.passwordImg}></div>
                                </div>

                                    {/*<div className='login-c-forgetPass'>*/}

                                        {/*<Input*/}
                                            {/*className="login-input login-input-checknum"*/}
                                            {/*type="text"*/}
                                            {/*placeholder="请点击输入验证码"*/}
                                            {/*name="codeImg" value={this.state.data.codeImg}  onChange={this.onInputChange.bind(this)}*/}
                                        {/*/>*/}

                                        {/*<img  src='' onClick={this.codeImg.bind(this)} id="img" alt=""/>*/}

                                        {/*<a href='mine.html#usercenter/forgetpassword'>忘记密码</a>*/}
                                    {/*</div>*/}



                            </div>
                                : null
                        }
                        {
                            this.state.model == 'phone' ? <div>
                                <div className="login-c-wrap icon-user">
                                    <Input
                                        className="login-input"
                                        placeholder="请输入手机号"
                                        name="tempPhone" value={this.state.data.tempPhone} onChange={this.onInputChange.bind(this)}
                                    />
                                </div>
                                <div className="login-c-wrap icon-msgcode">
                                    <Input
                                        className="login-input login-input-checknum"
                                        placeholder="验证码"
                                        name="smsCode" value={this.state.data.smsCode} onChange={this.onInputChange.bind(this)}
                                    />
                                    <Button text={this.state.btnCodeText} onClick={this.getSmCodeOne} noRadius={true} className="getCheckNum" disabled={this.state.discodeBtn} id='btn1'></Button>
                                </div>



                                    {/*<div className='login-c-forgetPass'>*/}
                                        {/*<a href='mine.html#usercenter/forgetpassword'>忘记密码</a>*/}
                                    {/*</div>*/}


                            </div>
                                : null
                        }


                        <div className='login-c-forgetPass'>

                            <Input
                                className="login-input login-input-checknum yzm"
                                type="text"
                                placeholder="请点击输入验证码"
                                name="codeImg" value={this.state.data.codeImg} onChange={this.onInputChange.bind(this)}
                            />

                            <span className='imgSpan'>
                                <img src='' onClick={this.codeImg.bind(this)} id="img" alt=""/>
                            </span>


                            <a href='mine.html#usercenter/forgetpassword'>忘记密码</a>
                        </div>




                        <div className="login-c-btn-wrap">
                            <button type="submit" className="login-btn">
                                {this.state.btnText}{' '}
                            </button>
                        </div>
                        <div className="protocol-privacy">
                            <CheckBox name=""
                                      checked={this.state.checked || false}
                                      onChange={this.checkboxChange.bind(this, this.state.checked)} />
                            <span className="text">
                                已阅读并同意:
                            </span>
                            <span className="color-b" onClick={this.openPdf.bind(this,1)}>平台服务协议</span>
                            <span>及</span>
                            <span className="color-b" onClick={this.openPdf.bind(this,2)}>隐私政策</span>
                        </div>
                    </div>
                    <div className='login-bottom'>
                        <div>
                            {/*<a href='http://www.caih.com/' target="_blank">中国东信<i>|</i></a>*/}
                            <a href='https://www.hisugar.com/' target="_blank">泛糖科技<i></i></a>
                            {/*<a href='http://www.hcgis.cn/' target="_blank">广州海川</a>*/}
                        </div>
                        <div>
        <p>桂ICP备16005301号-21</p>
                        </div>
                    </div>
                    <Modal
                        visible={this.state.modalVisible.resetPassword}
                        title="公告"
                        footer={null}
                        style={{
                            width: '500px',
                            height: '300px',
                            'max-height': $(window).height() - 150,
                            'margin-top': '-80px',

                        }}
                        onCancel={this.Cancels}
                        onOk={this.OKs}
                    >
                        <div>

                            <p style={{"text-align": "center", "font-size": 16}}>
                                广西糖料蔗大数据服务平台域名变更公告
                            </p>
                            <p>
                                尊敬的用户:
                                <br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您好！根据国务院办公厅《关于加强政府网站域名管理的通知》（国办函[2018]55号）、广西壮族自治区人民政府办公厅《关于规范政府网站名称及域名的通知》（桂政办电[2018]286号）要求，广西糖料蔗大数据服务平台域名变更为：https://www.iuscc.com，原IP
                                222.84.157.44:18180 将于12月31号停止使用，请您知悉。<br/>
                                <p style={{"text-align": "right"}}> 广西糖料蔗大数据服务平台</p>
                            </p>

                        </div>


                    </Modal>
                    <Modal
                        visible={this.state.resetPwdParam.resetPwd}
                        title="修改密码提示"
                        footer={null}
                        style={{
                            width: '500px',
                            height: '300px',
                            'max-height': $(window).height() - 150

                        }}
                        onCancel={this.closeResetPwd}
                        onOk={this.OKs}
                    >
                        <div className="reset-pwd">
                            <div className="reset-pwd-title">{this.state.resetPwdParam.msg}</div>
                            <div className="reset-pwd-btn">
                                <button className="reset-btn"
                                        onClick={this.toResetPwdPage.bind(this, 'username')}>原密码修改
                                </button>
                                <button className="reset-btn" onClick={this.toResetPwdPage.bind(this, 'phone')}
                                        style={{float: "right"}}>手机验证码修改
                                </button>
                            </div>
                            <div className='reset-pwd-txt'>
                                <a href="#" onClick={this.adminRelation.bind(this)}>联系工作人员重置密码>></a>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        visible={this.state.relationTag}
                        title="联系工作人员"
                        footer={null}
                        style={{
                            width: '500px',
                            height: '300px',
                            'max-height': $(window).height() - 150

                        }}
                        onCancel={this.closeRelation}
                        onOk={this.OKs}
                    >
                        <div className="admin-info">
                            <p className="username text">工作人员: {this.state.relation.username}</p>
                            <p className="phone text">联系电话: {this.state.relation.phone}</p>
                            <button type="button" className="btn-back" onClick={this.closeRelation.bind(this)}>返回
                            </button>
                        </div>
                    </Modal>
                    <Modal
                        visible={this.state.readVisible}
                        title="提示"
                        style={{
                            width: '500px',
                        }}
                        onCancel={this.closeRead}
                        onOk={this.okRead}
                        okText="同意并登录"
                    >
                        <div className="read-info">
                            <div>登录前请先阅读并同意</div>
                            <div>
                                <span className="color-b" onClick={this.openPdf.bind(this,1)}>平台服务协议</span>
                                <span>及</span>
                                <span className="color-b" onClick={this.openPdf.bind(this,2)}>隐私政策</span>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        visible={this.state.modalVisible.openOnePdf}
                        title='预览PDF'
                        style={{
                            'width': $(window).width(),
                            'max-height': $(window).height() - 150
                        }}
                        footer={null}
                        onCancel={this.onCancelPdf}
                    >
                        <div style={{ 'height': $(window).height() - 250, 'padding-left': '40px' }}>
                            {this.state.ieVersion > 8 || this.state.ieVersion == '-1' || this.state.ieVersion == 'edge' ?
                                <iframe src={'./../lib/SugarOrder/pdfjs/web/viewer.html?file=' + this.state.openOnePdfUrl} style={{ width: '100%', height: '100%', border: 'none' }}></iframe>
                                : <iframe src={this.state.openOnePdfUrl} style={{ width: '100%', height: '100%', border: 'none' }}></iframe>
                            }
                        </div>
                    </Modal>
                </form>
            </div>
        );
    }
}

ReactDOM.render(<Login/>, document.getElementById('J_content'));

module.exports = Login;



// WEBPACK FOOTER //
// ./js/login/login.js